module.exports = __webpack_public_path__ + "img/15.4d3f412a.png";